export default __webpack_public_path__ + "8650a62798aafb1237f3e4038165a0be.svg";